import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';
import { IcompanySpecialConfigDTO, ICompanySpecialConfigPage, ICompanySpecialConfigPageParam, ICompanySpecialConfigParam } from '@core/main/types';

const hostUrl = getHostbaseUrl();

/**
 * 企业特殊配置 - 特殊企业配置分页查询
 */
export async function queryCompanySpecialConfigPage(params: ICompanySpecialConfigPageParam) {
  let data = [] as ICompanySpecialConfigPage[];
  let total = 0;
  let idList = [] as any[];

  try {
    const { code, context, message } = await Http.post<{ data: any[]; total: number; idList: ICompanySpecialConfigPage[] }>(`${hostUrl}/side/company/special-config-page`, params);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all, idList: allIds } = context || {} as { data: any[]; total: number;idList: ICompanySpecialConfigPage[] };

      data = items || [] as ICompanySpecialConfigPage[];
      total = all || 0;
      idList = allIds || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total, 
    idList,
  };
}

/**
 * 企业特殊配置 - 企业特殊配置编辑
 */
export async function updateCompanySpecialConfig(params: ICompanySpecialConfigParam) {
  try {
    const { code, message } = await Http.post<void>(`${hostUrl}/side/company/company-special-config/edit`, params);

    if (code !== EAxiosResponseCode.Succeed) {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }
}

/**
 * 企业特殊配置 - 企业特殊配置信息查询
 */
export async function queryCompanySpecialConfigDetail(id: number) {
  let data = {} as IcompanySpecialConfigDTO;

  try {
    const { code, context, message } = await Http.get<IcompanySpecialConfigDTO>(`${hostUrl}/side/company/company-special-config/${id}/info`);

    if (code === EAxiosResponseCode.Succeed) {
      data = context || {} as IcompanySpecialConfigDTO;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return data;
}
